//
// Copyright (c) 2023 Emplifi, Inc.
//

import { Plugin } from "ckeditor5";
import AccordionEditing from "./accordionEditing";
import AccordionUi from "./accordionUi";
import AccordionToolbar from "./accordionToolbar";

export default class Accordion extends Plugin {
  static get requires() {
    return [AccordionEditing, AccordionToolbar, AccordionUi];
  }

  static get pluginName() {
    return "Accordion";
  }
}
